export const PRINT_LAYOUT = {
    width: '1275px',
    height: '1650px',
};

export const INTRO_PLACEHOLDER = `This space allows you to include your own personalized introduction.
    We recommend a friendly greeting to your readers and a brief reference to this week’s feature articles!`;

export const COMMENTARY_PLACEHOLDER = 'Here you can enhance your area’s housing market data with your own insights and commentary!';
